import { SET_USER_PROFILE, SET_LOADING } from "../actions/actionTypes";

export const setUserProfile = (payload) => {

	return {
		type: SET_USER_PROFILE,
		payload,
	};
};

export const setLoading = (payload) => {
	return {
		type: SET_LOADING,
		payload,
	};
}
